import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './public-landing.module.css';
import Login from '../Login/login';
import { isGovCloudRegion } from '../../utils/helpers';
import getQueryParams from '../../utils/query-params';
import { Box as Wrapper, Stack, Text, Flex } from '@tonic-ui/react';
import RouteLink from '../../components/route-link';

interface HeroBannerProps {
  showAlertBanner?: (arg: Record<string, string | boolean>) => void;
}

const { event = '' } = getQueryParams(window.location);

const FlexItem = () => {
  const { t } = useTranslation();

  const isMarketplaceUser =
    event === 'AWSMarketplaceSubscription' ||
    event === 'TrendMicroSubscription' ||
    event === 'AzureMarketplaceSubscription';

  return (
    <Wrapper color="white:primary">
      <Stack direction="column">
        <Text fontSize="56px" fontWeight="400" lineHeight="67px">
          {t('publicLandingPage.heroBanner.trendMicroTxt')}
        </Text>
        <Text
          fontSize="4xl"
          fontWeight={300}
          lineHeight="4xl"
          margin="16px 36px 0 0"
          className={styles.hero_banner_description}
        >
          {t('publicLandingPage.heroBanner.description')}
        </Text>
        {!isGovCloudRegion && (
          <Flex margin="68px 30px 0 0">
            <RouteLink
              id={isMarketplaceUser ? 'signUp-for-cloudone-button' : 'get-started-for-free-button'}
              href={isMarketplaceUser ? '/register' : '/trial'}
              className={styles.get_started_link}
              textDecoration="none"
              linkColor="red:60"
              padding="16px 40px"
              borderRadius="13px"
              fontWeight="semibold"
              fontSize="lg"
              lineHeight="md"
              backgroundColor="white:primary"
            >
              <Text>
                {isMarketplaceUser
                  ? t('publicLandingPage.heroBanner.signUpCloudOneBtnTxt')
                  : t('publicLandingPage.heroBanner.getStartedBtnTxt')}
              </Text>
            </RouteLink>
          </Flex>
        )}
      </Stack>
    </Wrapper>
  );
};

const HeroBanner = ({ showAlertBanner }: HeroBannerProps): JSX.Element => {
  return (
    <Wrapper className={styles.hero_banner}>
      <Flex className={styles.hero_banner_flex} data-id="hero-banner">
        <FlexItem />
        <Wrapper className={styles.hero_banner_login_wrap}>
          <Login hideHeading={true} showAlertBanner={showAlertBanner} />
        </Wrapper>
      </Flex>
    </Wrapper>
  );
};

HeroBanner.displayName = 'HeroBanner';

export default HeroBanner;
